
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ColorQuestionAnswerResult,
  CandidateResult,
  ColorAnswer
} from "@/lib/model/exam/result";

@Component({})
export default class MessageDialog extends Vue {
  @Prop({}) all!: CandidateResult;
  @Prop({ default: false }) isH5!: boolean;
  @Prop({ default: false }) inReport!: boolean;

  //色盲题结构
  get getColorTestQuestion(): ColorQuestionAnswerResult {
    return (
      this.all.answerList.find(item => item.type === 102)
        ?.colorQuestionAnswerResult || new ColorQuestionAnswerResult()
    );
  }
  //细分类型 变更 不分类型了
  questionListByType(): ColorAnswer[] {
    return this.getColorTestQuestion.colorAnswerList;
  }

  created() {
    //
  }
  mounted() {
    //   const a = this.exam;
  }
}
